import React from 'react';
import { Alert, Typography } from '@mui/material';

import { useMerchant } from '../contexts/MerchantContext';
import { useInheritedSettingsBannerContext } from '../contexts/InheritedSettingsBannerContext';
import { PARENT_HIERARCHY_SETTINGS_BANNER_MESSAGE } from '../util/parentSettingSave';

type Props = {
  /** Overrides the default config/settings inheritance message (e.g. webhooks). */
  message?: string;
};

/** Shown on configuration pages for parent merchants so users know saves may inherit below. */
export function ParentHierarchySettingsBanner({ message }: Props) {
  const { hasDescendants } = useMerchant();
  const { childInheritedInfoBannerActive } = useInheritedSettingsBannerContext();

  if (!hasDescendants || childInheritedInfoBannerActive) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 3 }} data-testid="parent-hierarchy-settings-banner">
      <Typography variant="medium" component="span" color="inherit">
        <Typography component="span" fontWeight={600} color="inherit">
          Note:
        </Typography>{' '}
        {message ?? PARENT_HIERARCHY_SETTINGS_BANNER_MESSAGE}
      </Typography>
    </Alert>
  );
}
